import styled from 'styled-components';
import Card from '@material-ui/core/Card';
import materialUI from '../../material-UI';
import color from '../../constants/color';

export const Container = styled.div`
  display: flex;
  height: 90vh;
  align-items: center;
  flex-direction: column;
`;
export const Header = styled.div`
  display: flex;
  align-items: center;
  height: 60px;
  border-bottom: 1px solid #dddddd;

  span {
    color: #333333;
  }
`;
export const Form = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 20px;
  padding: 20px;
`;

export const Cards = styled(Card)`
  margin-top: 20px;
`;

export const RowInput = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;
export const Sized = styled.div`
  height: 40px;
`;
export const ColumnForm = styled.div`
  justify-content: center;
  flex-direction: column;
  flex: 1;
`;
export const RowForm = styled.div`
  display: flex;
  flex-direction: row;
  flex: 1;
  margin-top: 30px;
  @media only screen and (max-width: 600px) {
    flex-direction: column;
  }
`;
export const Footer = styled.div`
  background-color: #F2F2F2;
  height: 60px;
  display: flex;
  margin-top: 20px;
  flex-direction: column;
  align-items: flex-end;
  justify-content: center;

  div {
    width: 170px;
  }
`;
export const ContainerRow = styled.div`
  display: flex;
  flex-direction: row;
`;
export const FooterTurn = styled.div`
  display: flex;
  flex-direction: row;
`;
export const FooterTurnContainerRight = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: 95px;

div {
  width: 200px;
  margin-right: 6px;
}
`;
export const Padding = styled.div`
  display: flex;
  width: 100%;
  margin-right: 10px;
`;
export const ContainerImage = styled.div`
  display: flex;
  max-width: 60%;
  margin-bottom: 20px;

  @media only screen and (max-width: 600px) {
    margin-top: 20px;
  }
`;
export const ContainerLoading = styled.div`
display: flex;
justify-content: center;`;

export const style = {
  column: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  img: {
    marginBottom: 40,
  },
  input: {
    marginBottom: 30,
  },
  text: {
    fontSize: 12,
    marginRight: 10,
    color: 'white',
    backgroundColor: '#333333',
    fontFamily: 'Graphik-Regular',
  },
  textButton: {
    fontSize: 12,
    marginTop: 20,
    marginBottom: 15,
    marginLeft: 16,
    color: 'white',
    backgroundColor: '#333333',
    fontFamily: 'Graphik-Regular',
  },
  textButtonTurno: {
    fontSize: 12,
    marginTop: 20,
    marginBottom: 15,
    marginLeft: 0,
    color: 'white',
    backgroundColor: '#333333',
    fontFamily: 'Graphik-Regular',
  },
};

// ->
export const ContainerForm = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: center;
  align-items: center;
  margin-top: 30px;
`;
export const CardForm: any = styled(materialUI.Card)`
  display: flex;
  flex-direction: row;
  border-radius: 8px;
  width: 80%;
  margin-bottom: 10px;

  @media only screen and (max-width: 748px) {
    flex-direction: column;
    width: 95%;
  }
`;
export const CardFormBody: any = styled.div`
  display: flex;
  background-color: ${(props: any) => props.color};
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 50%;
  height: 100%;
  padding: 0px 10px 0px 10px;
  min-height: 493px;


  @media only screen and (max-width: 748px) {
    width: 100%;
  }
  div {
    font-family: Inter;
  }
`;
export const Item: any = styled.div`
  display: flex;
  height: 52px;
  width: 100%;
  background-color: ${color.white};
  border-radius: 16px;
  align-items: center;
  margin: 0px 0px 8px 0px;

  div {
    color: ${color.VivazBlack};
    font-family: Inter;
    font-size: 0.95em;
  }
  @media only screen and (max-width: 733px) {
    div {
      font-family: Inter;
      margin-right: 8px;
      font-size: 0.90em;
      color: ${color.VivazBlack};
    }
    height: 56px;
  }
`;
export const Number = styled.div`
  div {
    margin: 0px 27px 0px 27px;
    color: ${color.greenButton}
  }
`;
export const MarginLeft = styled.div`
  padding: 0px 48px 0px 48px;
`;
export const Img: any = styled.img``;
export const Button = styled(materialUI.Button)`
  border-radius: 18px;
  color: ${color.white};
  height: 32px;
  width: 129px;
  background-color: ${color.primary};
  font-size: 10px;
  font-weight: normal;
`;
export const Title = styled.div`
  font-size: 24px;
  color: ${color.Black}
  font-family: Inter;
`;
export const Info = styled.div`
  font-size: 14px;
  color: ${color.Black}
  margin: 18px 0px 18px 0px;
  font-family: Inter;
  text-align: center;
`;
export const FooterBotton = styled.div`
  display: flex;
  width: 100%;
  margin-right: 58px;
  margin-top: 30px;
  justify-content: end;
`;
export const RowSelect = styled.div`
  display: flex;
  flex-direction: row;
`;

export const RowFormSelect: any = styled.div`
  display: flex;
  flex-direction: row;
  width: 40%;
  margin-top: 16px;
  align-items: center;
  cursor: pointer;


  div {
    font-size: 12px;
    font-family: Inter;
    margin-left: 16px;
    color: ${color.VivazBlack};
  }
`;
export const SizedBox = styled.div`
  height: 35px;
`;
export const Space = styled.div`
  height: 18px;
`;
export const PaddingContainer = styled.div`
  display: flex;
  padding: 0px 60px 0px 60px;
`;

export const RowInputs = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  align-items: center;
`;
export const BoxLoading = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  min-height: 493px;
  width: 100%;
  justify-content: center;
`;
export const Loading = styled(materialUI.CircularProgress)``;
export const CardEnd = styled(materialUI.Card)`
  display: flex;
  flex-direction: column;
  max-width: 290px;
  min-width: 290px;
  margin: 30px 0px 30px 0px;
`;
export const CardAction = styled.div``;
export const CardImages = styled(materialUI.CardMedia)``;
export const CardContent = styled(materialUI.CardContent)``;
export const CardImage = styled.div`
  display: flex;
  flex-direction: column;
`;
export const OnPress = styled(materialUI.IconButton)``;
export const CardBody = styled.div`
  display: flex;
  display: flex;
  flex-direction: column;
  width: 100%;
`;
export const CardRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: Row;
  padding: 16px 10px 0px 10px;
`;
export const Icon = styled.img`
`;
export const TitleCard = styled.div`
  font-family: Inter;
  color: ${color.grey10};
  font-size: 1.2em;
`;
export const SubTitleCard = styled.div`
  font-family: Inter;
  color: ${color.grey10};
  font-size: 0.85em;
  padding: 16px 10px 16px 10px;
`;
